/* Refresh Token Strategy Using Request Interceptor */

import axios from 'axios'

import keys from '@/config/keys'
import { buildEmmaDomainReferer } from '@/utils/buildEmmaDomainReferer'

/**
 * Add json cleaner to set undefined/null values to empty string.
 * This is to prevent axios(json to string using jsonify) from removing those keys
 * when converting json payload to string.
 */
function cleanJSON(json) {
	for (let key in json) {
		// if (json[key] === undefined || json[key] === null) {
		if (json[key] === undefined) {
			// json[key] = ''
			json[key] = null
		} else if (typeof json[key] === 'object') {
			if (json[key] instanceof File) continue
			json[key] = cleanJSON(json[key])
		}
	}
	return json
}

export default () => {
	// Add a axios request interceptor
	axios.interceptors.request.use(
		async (config) => {
			const href = typeof window !== 'undefined' ? window.location.href : ''

			// Set header to the current full URL
			config.headers[keys.AJAX_HEADER.REFERER] = href

			// Set header to the current URL Host + (Optional -> first path)
			config.headers[keys.AJAX_HEADER.DOMAIN_REFERER] = buildEmmaDomainReferer(href)

			// Convert undefined to null so that JSON.stringify can't omit it
			if (['post', 'put', 'patch'].includes(config.method)) {
				config.data = cleanJSON(config.data)
			}

			return config
		},
		function (error) {
			// Do something with request error
			return Promise.reject(error)
		},
	)
}
